import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-plant",
  "use": "icon-plant-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-plant\"><defs><style type=\"text/css\"></style></defs><path d=\"M512.42666666 5.33333333C235.94666666 5.33333333 10.66666666 230.61333333 10.66666666 507.09333333S235.94666666 1008.85333333 512.42666666 1008.85333333 1014.18666666 783.57333333 1014.18666666 507.09333333 788.90666666 5.33333333 512.42666666 5.33333333ZM215.46666666 814.29333333l53.248-182.272 135.168 133.12-188.416 49.152Zm221.184-69.632L299.43466666 599.25333333l335.872-309.248 137.216 137.216-335.872 317.44Zm376.832-337.92l-141.312-145.408s51.2-61.44 73.728-59.392c47.104 4.096 137.216 86.016 133.12 133.12-2.048 24.576-65.536 71.68-65.536 71.68Z\" fill=\"#e98f36\" p-id=\"3222\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/plant.svg
// module id = 3X3C
// module chunks = 40